<template>
  <div class="page-wrapper">
    <div class="page-header">
      <WidgetToolbar title="Dashboard" :icon="require('@/assets/admin-icon/menu/dashboard_active.svg')">
        <div class="options">
          <RoleManagement @onTeamSelected="TeamSelected" @onDeapartmentSelected="DeapartmentSelected"
            @onNoneSelected="NoneSelected"></RoleManagement>
        </div>
      </WidgetToolbar>
    </div>

    <div class="page-body">
      <!-- Heatmap for department and team -->
      <depTeamHeatmap v-if="heatmap_view_type == 'team' && show_hit_map" :value="heatmap_data" :loading="heatmap_loading"
        @prev="heatmapPrev" @next="heatmapNext"></depTeamHeatmap>

      <!-- Heatmap for members -->
      <membersHeatmap v-if="heatmap_view_type == 'member' && show_hit_map" :value="heatmap_data"
        :loading="heatmap_loading" @prev="heatmapPrev" @next="heatmapNext"></membersHeatmap>
    </div>

    <!-- Startup wizard -->
    <StartUpWizard v-if="show_wizard" @checkWizard="manageWizard"></StartUpWizard>
  </div>
</template>

<script>
import { eventBus } from "@/main";
import StartUpWizard from "./components/StartUpWizard.vue";
import depTeamHeatmap from "@/views/Dashboard/components/dep_team_heatmap.vue";
import membersHeatmap from "@/views/Dashboard/components/members_heatmap.vue";
export default {
  name: "dashboard",
  components: {
    StartUpWizard,
    depTeamHeatmap,
    membersHeatmap,
  },
  data() {
    return {
      heatmap_loading: false,
      box_modal_style: {},
      show_wizard: true,
      view_type: null,
      heatmap_data: {
        data: [],
        labels: [],
      },
      show_hit_map: false,
      team_ids: [],
      department_ids: [],
      heatmap_view_type: "",
    };
  },
  watch: {},
  mounted() { },
  methods: {
    NoneSelected() {
      let vm = this;
      vm.getTeamsData();
    },
    getTeamsData() {
      let vm = this;
      vm.$store.dispatch("LOADER_START");
      vm.$store
        .dispatch("GET_ALL_USER_INFO")
        .then((response) => {
          if (vm.$localStorage.get("role") == "team-manager") {
            vm.team_ids = response.data.map((item) => item.id);
            vm.TeamSelected(vm.team_ids);
          } else {
            vm.department_ids = response.data.map((item) => item.id);
            vm.getHeatMapData();
          }
        })
        .catch((error) => {
          console.error({ error });
        });
    },
    TeamSelected(team_id) {
      let vm = this;
      vm.team_ids = team_id;
      vm.heatmap_view_type = "member";
      vm.show_hit_map = false;
      vm.$store.dispatch("LOADER_START");
      vm.$store
        .dispatch("HEATMAP_GET_ALL_DATA", {
          teams: vm.team_ids,
          prefix: "team-manager",
        })
        .then((response) => {
          vm.$store.dispatch("LOADER_CLOSE");
          vm.heatmap_data = response.data;
          vm.heatmap_data.data = vm.heatmap_data.data.map((item) => {
            if (vm.heatmap_data.data.length == 1) {
              eventBus.$set(item.team, "item_expanded", true);
            } else {
              eventBus.$set(item.team, "item_expanded", false);
            }
            eventBus.$set(item.team, "modal", false);
            item.consultants = item.consultants.map((member) => {
              eventBus.$set(member, "modal", false);
              eventBus.$set(member, "item_expanded", false);
              return member;
            });
            return item;
          });
          vm.show_hit_map = true;
          setTimeout(() => {
            vm.heatmapPrev();
          }, 500);
        })
        .catch((error) => {
          vm.$store.dispatch("LOADER_CLOSE");
          console.error({ error });
        });
    },
    DeapartmentSelected(department_id) {
      let vm = this;
      vm.department_ids = department_id;
      vm.heatmap_view_type = "team";
      vm.show_hit_map = false;
      vm.$store.dispatch("LOADER_START");
      vm.$store
        .dispatch("HEATMAP_GET_ALL_DATA", {
          departments: vm.department_ids,
          prefix: "super-manager",
        })
        .then((response) => {
          vm.show_hit_map = true;
          vm.$store.dispatch("LOADER_CLOSE");
          vm.heatmap_data = response.data;
          vm.heatmap_data.data = vm.heatmap_data.data.map((item) => {
            if (vm.heatmap_data.data.length == 1) {
              eventBus.$set(item.department, "item_expanded", true);
            } else {
              eventBus.$set(item.department, "item_expanded", false);
            }
            eventBus.$set(item.department, "modal", false);
            item.teams = item.teams.map((team) => {
              eventBus.$set(team, "modal", false);
              eventBus.$set(team, "item_expanded", false);
              return team;
            });
            return item;
          });
          setTimeout(() => {
            vm.heatmapPrev();
          }, 500);
        })
        .catch((error) => {
          vm.$store.dispatch("LOADER_CLOSE");
          console.error({ error });
        });
    },
    getHeatMapData() {
      let vm = this;
      vm.show_hit_map = false;
      vm.heatmap_view_type = "team";
      vm.$store.dispatch("LOADER_START");
      vm.$store
        .dispatch("HEATMAP_GET_ALL_DATA", {
          departments: vm.department_ids,
          prefix: "super-manager",
        })
        .then((response) => {
          vm.show_hit_map = true;
          vm.heatmap_data = response.data;
          vm.heatmap_data.data = vm.heatmap_data.data.map((item) => {
            if (vm.heatmap_data.data.length == 1) {
              eventBus.$set(item.department, "item_expanded", true);
            } else {
              eventBus.$set(item.department, "item_expanded", false);
            }
            eventBus.$set(item.department, "modal", false);
            item.teams = item.teams.map((team) => {
              eventBus.$set(team, "modal", false);
              eventBus.$set(team, "item_expanded", false);
              return team;
            });
            return item;
          });
          setTimeout(() => {
            vm.heatmapPrev();
          }, 500);
        })
        .catch((error) => {
          vm.$store.dispatch("LOADER_CLOSE");
          console.error({ error });
        });
    },
    heatmapPrev(type = "") {
      let vm = this;
      vm.heatmap_loading = true;
      let scoll_element = document.querySelector("#department-table-content");
      let start_sroll_width =
        scoll_element.scrollWidth - scoll_element.offsetWidth;

      let payload = vm.heatmap_data.labels[0];
      let prefix = "";
      if (vm.heatmap_view_type == "team") {
        eventBus.$set(payload, "departments", vm.department_ids);
        prefix = "/super-manager";
      }
      if (vm.heatmap_view_type == "member") {
        eventBus.$set(payload, "teams", vm.team_ids);
        prefix = "/team-manager";
      }
      eventBus.$set(payload, "prefix", prefix);
      vm.$store
        .dispatch("HEATMAP_GET_PREV_DATA", payload)
        .then((response) => {
          vm.$store.dispatch("LOADER_CLOSE");
          vm.heatmap_loading = false;
          response.data.labels.reverse().forEach((item) => {
            vm.heatmap_data.labels.unshift(item);
          });

          response.data.data.forEach((item, index) => {
            if (vm.heatmap_view_type == "member") {
              item.team.data.reverse().forEach((tea) => {
                vm.heatmap_data.data[index].team.data.unshift(tea);
              });
              item.consultants.forEach((consultant, consultant_index) => {
                consultant.data.reverse().forEach((team_piece) => {
                  vm.heatmap_data.data[index].consultants[
                    consultant_index
                  ].data.unshift(team_piece);
                });
              });
            }
            if (vm.heatmap_view_type == "team") {
              item.department.data.reverse().forEach((dep) => {
                vm.heatmap_data.data[index].department.data.unshift(dep);
              });

              item.teams.forEach((team, team_index) => {
                team.data.reverse().forEach((team_piece) => {
                  vm.heatmap_data.data[index].teams[team_index].data.unshift(
                    team_piece
                  );
                });
              });
            }
          });
          setTimeout(() => {
            let end_scoll_width =
              scoll_element.scrollWidth - scoll_element.offsetWidth;
            if (type == "") {
              scoll_element.scrollLeft += end_scoll_width - start_sroll_width;
            } else {
              scoll_element.scrollLeft = 0;
            }
          }, 50);
        })
        .catch((error) => {
          vm.heatmap_loading = false;
          console.error({ error });
        });
    },
    heatmapNext(type = "") {
      let vm = this;
      vm.heatmap_loading = true;
      let scoll_element = document.querySelector("#department-table-content");
      let last_index = vm.heatmap_data.labels.length - 1;
      let payload = vm.heatmap_data.labels[last_index];
      let prefix = "";
      if (vm.heatmap_view_type == "team") {
        eventBus.$set(payload, "departments", vm.department_ids);
        prefix = "/super-manager";
      }
      if (vm.heatmap_view_type == "member") {
        eventBus.$set(payload, "teams", vm.team_ids);
        prefix = "/team-manager";
      }
      eventBus.$set(payload, "prefix", prefix);

      vm.$store
        .dispatch("HEATMAP_GET_NEXT_DATA", payload)
        .then((response) => {
          vm.heatmap_loading = false;

          response.data.labels.forEach((item) => {
            vm.heatmap_data.labels.push(item);
          });
          response.data.data.forEach((item, index) => {
            if (vm.heatmap_view_type == "member") {
              item.team.data.forEach((tea) => {
                vm.heatmap_data.data[index].team.data.push(tea);
              });
              item.consultants.forEach((consultant, consultant_index) => {
                consultant.data.forEach((team_piece) => {
                  vm.heatmap_data.data[index].consultants[
                    consultant_index
                  ].data.push(team_piece);
                });
              });
            }
            if (vm.heatmap_view_type == "team") {
              item.department.data.forEach((dep) => {
                vm.heatmap_data.data[index].department.data.push(dep);
              });
              item.teams.forEach((team, team_index) => {
                team.data.forEach((team_piece) => {
                  vm.heatmap_data.data[index].teams[team_index].data.push(
                    team_piece
                  );
                });
              });
            }
          });

          setTimeout(() => {
            let end_scoll_width =
              scoll_element.scrollWidth - scoll_element.offsetWidth;
            if (type == "scoll") {
              scoll_element.scrollLeft += end_scoll_width;
            }
          }, 40);
        })
        .catch((error) => {
          vm.heatmap_loading = false;
          console.error({ error });
        });
    },
    manageWizard(status) {
      let vm = this;
      vm.show_wizard = status;
    },
  },
  computed: {},
};
</script>

<style lang="scss" scoped>
.page-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #ebebeb;
  padding: 5px;

  .page-header {
    height: 38px;
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 5px;

    .options {
      display: flex;
      align-items: center;
    }
  }

  .page-body {
    height: calc(100% - 43px);
    border-radius: 5px;
    display: flex;
    flex-direction: column;
  }
}
</style>
